export enum BASE_URL {
  DASHBOARD = 'dashboard',
}

export enum DASHBOARD_SECTIONS_ROUTES {
  STATISTICS = 'statistics',
  PAYOUT_ORDER = 'payout-order',
  DOCUMENTS = 'documents',
}

export enum STATISTICS_PERMISSIONS {
  GET_STATISTICS_REPORT_LIST = 'backofficeapi_report_statistic_report',
  GET_TOP_WINS_HISTORY_LIST = 'backofficeapi_report_get_top_wins_history',
  GET_PLAYERS_REPORT_COUNT = 'backofficeapi_dashboard_get_players_report',
}

export enum PAYOUT_ORDER_PERMISSIONS {
  GET_PAYOUT_ORDER_LIST = 'backofficeapi_dashboard_get_payout_order_v2',
  UPDATE_TRANSACTION_MODERATION_INFO_MANUAL_FLOW =
  'backofficeapi_player_update_transaction_moderation_info_manual_flow',
  UPDATE_TRANSACTION_MODERATION_INFO_FORCE_TAKE = 'backofficeapi_player_update_transaction_moderation_info_force_take',
  GET_TRANSACTION_MODERATION_INFO = 'backofficeapi_player_bp_wl_transaction_moderation_info',
  GET_PAYMENT_LIST = 'backofficeapi_player_get_payment_list',
  GET_PAYMENT_MODERATION_ACTION_LIST = 'backofficeapi_player_get_payment_moderation_action',
  UPDATE_TRANSACTION_MODERATION_INFO = 'backofficeapi_player_update_transaction_moderation_info',
}

export enum DOCUMENTS_PERMISSIONS {
  GET_DOCUMENT_LIST = 'backofficeapi_dashboard_get_file_v2_list',
  UPDATE_TRANSACTION_MODERATION_INFO_FLOW = 'backofficeapi_update_document_moderation',
  GET_DOCUMENT_MODERATION_FILTER_STATUS_LIST = 'backofficeapi_dictionary_get_document_moderation_filter_status_list',
}

export type DashboardPermissions = {
  [DASHBOARD_SECTIONS_ROUTES.STATISTICS]: { [key in STATISTICS_PERMISSIONS]: boolean };
  [DASHBOARD_SECTIONS_ROUTES.PAYOUT_ORDER]: { [key in PAYOUT_ORDER_PERMISSIONS]: boolean };
  [DASHBOARD_SECTIONS_ROUTES.DOCUMENTS]: { [key in DOCUMENTS_PERMISSIONS]: boolean };
};
